import { BaseCarousel } from './base-carousel'
export class HBCarousel extends BaseCarousel {
  constructor () {
    super({
      arrowShape: 'M 75 53.125 C 76.726562 53.125 78.125 51.726562 78.125 50 C 78.125 48.273438 76.726562 46.875 75 46.875 Z M 22.789062 47.789062 C 21.570312 49.011719 21.570312 50.988281 22.789062 52.210938 L 42.679688 72.097656 C 43.898438 73.316406 45.875 73.316406 47.097656 72.097656 C 48.316406 70.875 48.316406 68.898438 47.097656 67.679688 L 29.417969 50 L 47.097656 32.320312 C 48.316406 31.101562 48.316406 29.125 47.097656 27.902344 C 45.875 26.683594 43.898438 26.683594 42.679688 27.902344 Z M 75 46.875 L 25 46.875 L 25 53.125 L 75 53.125 Z M 75 46.875',
      prevNextButtons: true,
      groupCells: true,
      mobilePercentPosition: false,
      desktopPercentPosition: false,
      lazyLoad: 2
    })
  }
}

customElements.define('hb-carousel', HBCarousel)
